import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=ac5a9d12&scoped=true&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=ac5a9d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a9d12",
  null
  
)

export default component.exports